var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmsOrganizer(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 192 192",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinejoin: "round",
    strokeWidth: 12,
    d: "M30 54c0-13.255 10.745-24 24-24h84c13.255 0 24 10.745 24 24v84c0 13.255-10.745 24-24 24H30V54Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeWidth: 12,
    d: "M54 96h84m-84 24h60M54 72h36"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmsOrganizer);
export default __webpack_public_path__ + "static/media/sms-organizer.170089cd65bd240dd8e8b445ebab3f88.svg";
export { ForwardRef as ReactComponent };